import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 12 9" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10.62 0L3.98 6.28 1.33 3.93 0 5.43 4.03 9 12 1.45z" fill="#000" fillRule="evenodd" /></svg>);